import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, Typography } from "@mui/material";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import SelloutRegiao from "./components/SelloutRegiao";
import ComparativoCobertura from "./components/ComparativoCobertura";
import DesempenhoCategoria from "./components/DesempenhoCategoria";
import PerformanceProduto from "./components/PerformanceProduto";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

function CategoriasDesktop({ app }) {
  const { isLoading } = useOverviewData(app);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={2}
          >
            {isLoading ? (
              <Grid container spacing={2} sx={{ marginTop: "37px" }}>
                {/* First row - 2 columns */}
                <Grid item xs={12} md={6}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>

                {/* Second row - 4 equal columns */}
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginTop: "37px" }}>
                <Box className="container-card-title">
                  <Typography variant="h1" className="title">
                    Performance por Categoria
                  </Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} className="container-tables-tops">
                    <SelloutRegiao app={app} />
                  </Grid>
                  <Grid item xs={12} md={6} className="container-tables-tops">
                    <ComparativoCobertura app={app} />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} className="container-tables-tops">
                    <PerformanceProduto app={app} />
                  </Grid>
                  <Grid item xs={12} md={6} className="container-tables-tops">
                    <DesempenhoCategoria app={app} />
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid item spacing={2}>
            <Footer app={app} />
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

CategoriasDesktop.propTypes = {
  app: PropTypes.object,
};

export default CategoriasDesktop;
